import {
    IListState,
    initialListState
} from '../shared/list/list.state';

export interface IDriversState {
    drivers: IListState;
    viewedDriverId: string;
}

export function initialDriversState(): IDriversState {
    return {
        drivers: {
            ...initialListState
        },
        viewedDriverId: null
    };
}
